export default class ProjectFormulationProposalsListCtrl {
  constructor ($scope, $stateParams, $timeout, WorkPlanSrv, WorkPlanModalSrv, GlobalConfig, $cookies, $state, $mdDialog, $filter, Requests, $sessionStorage) {
  // constants
    const projectVM = this
    projectVM.currentUser = JSON.parse($cookies.get('currentUser'))
    projectVM.subModuleId = JSON.parse($cookies.get('subModuleId'))
    projectVM.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    projectVM.$sessionStorage = $sessionStorage

    let post = {
      teacherId: projectVM.currentUser.teacherId,
      workplanId: projectVM.currentUser.workplanId
    }

  // variables
    projectVM.showData = false
    projectVM.viewLoaded = false
    projectVM.criteriaFilter = ''
    projectVM.selectedProposal = null
    projectVM.detailsData = null
    projectVM.proposals = []
    projectVM.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')
    projectVM.sr = ''
    projectVM.searchValue = false
    projectVM.feedback = 0
    projectVM.planningFinish = true
    projectVM.active = GlobalConfig.generals.active
    projectVM.notActive = GlobalConfig.generals.notActive
    $scope.classPlanning = ''

  // methods
    projectVM.details = details
    projectVM.updateSearchView = updateSearchView
    projectVM.tagClas = tagClass
    projectVM.proposalBckgrd = proposalBckgrd
    projectVM.proposalText = proposalText
    projectVM.getReviewData = getReviewData
    projectVM.close = close
    projectVM.confirmDeleteProposal = confirmDeleteProposal
    projectVM.thereIsDetails = thereIsDetails
    projectVM.updateFilter = updateFilter
    projectVM.download = download
    projectVM.getGeneralsWorkplan = getGeneralsWorkplan
    projectVM.bitacora = bitacora

    angular.extend(projectVM, {
      isLoadingDetails : false,
      filter:''
    })
  
    activate()

    function download(){
      var HTML = document.getElementById('doc')
      var title = '<h2>'+projectVM.detailsData.titleProject+'</h2>'
      var xt = HTML.getElementsByClassName("export")[0].innerHTML
      var htmlDocument = '<html><head><meta charset="utf-8"></head><body>'+title+xt+'</body></html>';
      var dataUri = 'data:text/html,' + encodeURIComponent(htmlDocument)
      projectVM.direct = dataUri
      return false
    }

    function activate () {
      if(projectVM.workPlanGeneralList != undefined){
        projectVM.status = projectVM.workPlanGeneralList.wokplanTeacherStatus[0]
        projectVM.stages = projectVM.workPlanGeneralList.stages
        projectVM.feedback = projectVM.status.feedbackReviewed
        projectVM.workplanTeacherId = projectVM.status.workplanTeacherId
        isPlanning(projectVM.status, projectVM.stages)
        
        if(projectVM.feedback && !projectVM.planningFinish){
          getReviewDataReject()
        }else{
          getReviewData()
        }
      }else{
        getGeneralsWorkplan(post).then((promise) => {
          if(projectVM.feedback && !projectVM.planningFinish){
            getReviewDataReject()
          }else{
            getReviewData()
          }
        })
      }
    }

    function getReviewData () {

      WorkPlanSrv.getListFormulatedExtensionProjects.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            projectVM.proposals = dataReturn.listExtension
            if(projectVM.proposals.length==0){
              projectVM.detailsData = true
            }

            for (var i = projectVM.proposals.length - 1; i >= 0; i--) {
              if (projectVM.proposals[i].activityTypeId == GlobalConfig.typeProject.internalProject){
                projectVM.proposals[i].activityTypeName = 'Proyecto Interno'
              }else{
                projectVM.proposals[i].activityTypeName = 'Proyecto Transversal'
              }
            }

            if(projectVM.proposals && projectVM.proposals.length > 0)
              projectVM.details(projectVM.proposals[0])

          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log()
        }
      )
    }

    function getReviewDataReject () {

      WorkPlanSrv.getListFormulatedExtensionProjectsReject.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            projectVM.proposals = dataReturn.listExtension
            if(projectVM.proposals.length==0){
              projectVM.detailsData = true
            }

            if(projectVM.proposals.length == 0)
              projectVM.detailsData = 0


            for (var i = projectVM.proposals.length - 1; i >= 0; i--) {
              if (projectVM.proposals[i].activityTypeId == GlobalConfig.typeProject.internalProject){
                projectVM.proposals[i].activityTypeName = 'Proyecto Interno'
              }else{
                projectVM.proposals[i].activityTypeName = 'Proyecto Transversal'
              }
            }

            if(projectVM.proposals && projectVM.proposals.length > 0)
              projectVM.details(projectVM.proposals[0])

          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log()
        }
      )
    }

    function getProposalsDetails (proposals, reload = false, callback) {
      WorkPlanSrv.getFormulatedExtensionProjectsById.get({workplanTeacherActivityId: proposals.workplanTeacherActivityId}).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            projectVM.detailsData = dataReturn.listExtension[0]
              if (projectVM.detailsData.activityTypeId == GlobalConfig.typeProject.internalProject){
                projectVM.detailsData.activityTypeName = 'Proyecto Interno'
              }else{
                projectVM.detailsData.activityTypeName = 'Proyecto Transversal'
              }
              //projectVM.detailsData.startDate = moment(projectVM.detailsData.startDate).format('DD/MM/YYYY')
              //projectVM.detailsData.endDate = moment(projectVM.detailsData.endDate).format('DD/MM/YYYY')
          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log()
        }
      )
      
      if (!reload) {
        projectVM.isLoadingDetails = true
        projectVM.detailsData = null
      }
      callback
    }

    function thereIsDetails () {
      return Boolean(projectVM.detailsData)
    }

    function tagClass (proposal) {
        return 'azul'
    }

    function proposalBckgrd (proposal) {
      if (projectVM.selectedProposal === proposal) {
        return 'bg-review'
      }
    }

    function proposalText (proposal) {
      if (projectVM.selectedProposal === proposal) {
        return 'text-color-w'
      }
    }

    function details (proposal) {
      projectVM.detailsData = null
      projectVM.selectedProposal = proposal
      projectVM.isLoadingDetails = true
      getProposalsDetails(proposal, function(){
        projectVM.isLoadingDetails = false
      })
    }

    function close(){
      return $mdDialog.hide()
    }

    function updateFilter (val) {
      projectVM.sr = validateSearch()
      if (projectVM.sr.length == 0){
        console.log(projectVM.sr)
        projectVM.searchValue = true
        projectVM.detailsData = null
      }else{
        projectVM.searchValue = false
        if(projectVM.proposals && projectVM.proposals.length > 0)
          projectVM.details(projectVM.proposals[0])
      }
    }

    function updateSearchView () {
      projectVM.viewLoaded = true
      projectVM.viewLoaded = false
      $timeout(() => {
        projectVM.viewLoaded = true
      }, 100)
    }

    function confirmDeleteProposal (proposal) {   
      let name = proposal.titleProject
      let workplanTeacherActivityId = proposal.workplanTeacherActivityId
      $mdDialog.show({
        controller: [ '$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
          let ctrlModalVM = this
          ctrlModalVM.name = name
          ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId
          ctrlModalVM.close = function () {
            $mdDialog.hide()
          }
          ctrlModalVM.delete = function () {
            WorkPlanSrv.disableActivityResearch.delete({workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId})
            .$promise.then(function (dataReturn) {
              if (dataReturn.status) {
                removeFromlist(proposal)
                showDeletedSuccessfully(ctrlModalVM.name)
                $mdDialog.hide()
              } else {
                console.log('Comunications problem with the server')
              }
            }, function (data) {

            })
            
          }
        }],
        controllerAs: 'ctrlModalVM',
        template: require('./deleteModal.html'),
        clickOutsideToClose: false
      })
    }

    function showDeletedSuccessfully(name){

      let texts = GlobalConfig.appTexts
      let header = {
        createOrEdit     : texts.deleteDialog,
        textCreateOrEdit : texts.deleted,
        itemName         : name,
        nameModal        : texts.modalTypeName.deleted,
        modalType        : texts.modalTypeId.default
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })   

    }
    
    function removeFromlist(proposal){
      for(var i in projectVM.proposals){
        if(projectVM.proposals[i].workplanTeacherActivityId === proposal.workplanTeacherActivityId){
          projectVM.proposals.splice(i,1)
        updateSearchView()
          break
        }
      }
    }

    function getGeneralsWorkplan(post){
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          projectVM.$sessionStorage.workPlanGeneralList = dataReturn.data
          projectVM.status = dataReturn.data.wokplanTeacherStatus[0]
          projectVM.stages = dataReturn.data.stages
          projectVM.feedback = projectVM.status.feedbackReviewed
          projectVM.workplanTeacherId = projectVM.status.workplanTeacherId
          isPlanning(projectVM.status, projectVM.stages)
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data);
      })
    }

    function isPlanning(status, stages){
      projectVM.currentDate = moment(new Date()).format("DD/MM/YYYY")
      for (var i = stages.length - 1; i >= 0; i--) {
        if(stages[i].stageId == GlobalConfig.workplanIdStages.review){
          projectVM.startDateStage = stages[i].startDate
        }
      }

      if(status.workplanActive){
        if (status.planningFinish == projectVM.active){        
          projectVM.planningFinish = true
          if (projectVM.startDateReview < projectVM.currentDate || status.reviewedFinish == projectVM.active){
            projectVM.planningFinish = true
          }else if (status.reviewedReject == projectVM.active){
            projectVM.planningFinish = false
          }
        } else {
            projectVM.planningFinish = false
        }
      }else{
        projectVM.planningFinish = true
      }

      $scope.classPlanning = (projectVM.planningFinish ? "disabled" : " ")
    }

    function validateSearch() {
      return $filter('filter')(projectVM.proposals, projectVM.criteriaFilter)
    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.internalProjectsFormulation,
        workplanTeacherId: projectVM.workplanTeacherId
      }
      entries.title = 'Formulación de propuesta de extensión'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }

  }
  
}

ProjectFormulationProposalsListCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalConfig', '$cookies', '$state', '$mdDialog', '$filter', 'Requests', '$sessionStorage']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/extensionVisibility/projectFormulation/list/projectFormulationProposalsListCtrl.js